import React from 'react';
import { MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-navydark px-3 py-5 sm:px-5" data-id="element-88" data-mp="3gf958x4mo89h">
      <div className="mx-auto max-w-2xl text-center" data-id="element-89" data-mp="3ggu1qsai619z">
        <p className="font-head text-lg uppercase leading-none text-white sm:text-2xl" data-id="element-90" data-mp="32oe1u0cwejda">
          Kids Learning Ready™
        </p>
        <p className="mt-1 text-[12px] leading-snug text-white/70" data-id="element-91" data-mp="36q93x72nl0s4">
          The Complete Visual Learning System for Kids. Because helping a child learn shouldn’t mean
          starting from zero every time.
        </p>

        <p className="mt-1.5 flex items-center justify-center gap-1.5 text-[12px] text-white/75" data-id="element-92" data-mp="36muiocgf6ul">
          <MailIcon className="h-3.5 w-3.5 text-orange" aria-hidden="true" data-id="element-93" data-mp="3lggbusv1b1ek" />
          Support:{' '}
          <a href="mailto:kitonline27@gmail.com" className="underline transition-colors duration-150 ease-out hover:text-orange" data-id="element-94" data-mp="3qfjj8jyhljpp">
            kitonline27@gmail.com
          </a>
        </p>

        <p className="mt-1.5 text-[10px] text-white/50" data-id="element-95" data-mp="2ezl35w4w5xez">© 2026 Kit Online — All Rights Reserved.</p>
        <p className="mt-0.5 text-[10px] text-white/50" data-id="element-96" data-mp="3l9shh1e8ymmw">
          Terms &amp; Conditions · Privacy Policy · Contact
        </p>
      </div>
    </footer>;
}